import React, { useEffect } from 'react';
import SEO from '../components/seo';
import ComponentList from '../components/ComponentList';
import ProductHero from '../components/ProductHero';

const ProductPage = ({ pageContext, location }) => {
  const { seo = {}, product = {} } = pageContext;
  const { components = [] } = product;
  const { state } = location;

  const metaTitle = `${product.title} | Eugenie Detroit` || 'Eugenie Detroit';
  const openGraphTitle =
    `${product.title} | Eugenie Detroit` || 'Eugenie Detroit';
  const twitterTitle =
    `${product.title} | Eugenie Detroit` || 'Eugenie Detroit';


    useEffect(() => {
      const productAnalyticsObject = {
        id: product.productId,
        title: product.title,
        price: product.cents,
        compareAtPrice: product.compareAtCents && product.compareAtCents,
        productUrl: `https://eugeniedetroit.com/products/${product.slug}`,
        imageUrl: product.shopifyImage,
      };
      window.analytics && window.analytics.productView(productAnalyticsObject);
    }, []);

  return (
    <React.Fragment>
      <SEO
        metaTitle={metaTitle}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={openGraphTitle}
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={seo?.openGraphImage}
        twitterTitle={twitterTitle}
        twitterDescription={seo?.twitterDescription}
        twitterImage={seo?.twitterImage}
        pathname={location.pathname}
      />
      <ProductHero {...state} {...product} />
      {components && <ComponentList components={components} />}
    </React.Fragment>
  );
};

export default ProductPage;
